import * as BABYLON from "babylonjs"; //5.0.0-rc.2
import "babylonjs-loaders/babylonjs.loaders.min.js";
import 'babylonjs-procedural-textures';
// import * as GUI from "babylonjs-gui";
// import "babylonjs-inspector"; // 注释掉：该包使用了?.可选链语法，webpack3+babel6无法解析
import { Camera } from "./Camera";
import { Scene } from "./Scene";
import { Loader } from "./Loader";
import { EventBus } from "./EventBus";
import { Project } from "./Object/Project";
import { worldToScreen, sleep } from "./Tools/index";
import { mashShow, meshHide } from "./Animate";
import { Product } from "./Object/Product";
import { ProductIn } from "./Object/ProductIn";
import { Equipment } from "./Object/Equipment";
import { addRoads,addGrass,addSky,addScene,addPoiLight } from "./Object/Env";
import {genPingtaiMat} from "./Mats/PingtaiMat"
import _ from "lodash";
import config from "./config";
export class LevelsShow {
  projects = {};
  activeProject;
  activeOut = null;
  activeIn = null;
  constructor() {
    if (!LevelsShow.instance) {
      LevelsShow.instance = this;
      this.init();
      // let resize = _.debounce(
      //   this.engine.resize
      // , 300)
      window.addEventListener("resize", () => {
        this.engine.resize();
      });
    }
    return LevelsShow.instance;
  }
  async switchProject(projectInfo) {
    await this.loader.end();
    if (this.project) {
      // this.scene.removeMesh(this.project.mesh)
      // this.project.distroy()
    }
    if (this.activeProject) {
      for (const key in this.projects) {
        if (Object.hasOwnProperty.call(this.projects, key)) {
          if (key != "project" + projectInfo.id) {
            this.projects[key].destroy();
            this.projects[key] = null;
            delete this.projects[key];
          }
        }
      }
    }
    this.productInshide();
    levelsShowIns.eventbus.$emit('levelchange', 0);
    levelsShowIns.eventbus.$emit('inpois', []);
    this.projectInfo = projectInfo
    this.camera.position = new BABYLON.Vector3(1, -1, 1);
    let project = new Project(projectInfo);
    this.projects[project.mesh.id] = project;
    this.activeProject = project;
  }

  setData() {
    this.setWarning();
  }
  //加载内部产品
  async meshIn(mesh,logo) {
    mesh.isPickable = false
    logo.isPickable = false
    if (mesh.$type.indexOf("product") > -1) {
      let animation = meshHide(mesh, this.scene);
      let animation2 = meshHide(logo, this.scene);
      this[mesh.$type + "In"] = new ProductIn(mesh.$type);
    } else {
      // this.ProductIn = new Equipment(mesh);
    }
    this[mesh.$type + "In"].show(mesh);
    return false;
  }
  setWarning() {}
  initColors(){
    this.initcolors = {}
    this.initcolors.product1 = new BABYLON.Color4(0.739, 0.639, 0.623, 1)
    this.initcolors.product2 = new BABYLON.Color4(.5, .5, .5, 1)
    this.initcolors.product3 = new BABYLON.Color4(.5, .5, .5, 1)
    this.initcolors.product4 = new BABYLON.Color4(1, 1, 1, 1)
    this.initcolors.product5 = new BABYLON.Color4(0.480, 0.51, 0.506, 1)
    this.initcolors.product6 = new BABYLON.Color4(.5, .5, .5, 1)
    this.initcolors.product7 = new BABYLON.Color4(.5, .5, .5, 1)
    this.initcolors.powerBox = new BABYLON.Color4(0.480, 0.510, 0.5060, 1)
    this.initcolors.electricalBox = new BABYLON.Color4(0.80, 0.723,0.643, 1)
    this.initcolors.battery = new BABYLON.Color4(1, 1, 1, 1)
    this.initcolors.highVoltage = new BABYLON.Color4(1, 1, 1, 1)
    this.initcolors.errorColor = new BABYLON.Color4(1, 0, 0, 1)
    this.initcolors.warningColor = new BABYLON.Color4(0, 0, 1, 1)
  }
  objectWarn(id,warn){
    let mesh = levelsShowIns.scene.getMeshByID(meshid)
  }
  meshWarn(meshid,warn){
    let color
    let mesh = levelsShowIns.scene.getMeshByID(meshid)
    if(warn == 0 ){
      color =  this.initcolors[mesh.$type]
    }
    if(warn == 1 ){
      color = this.initcolors.warningColor
    }
    if(warn == 2 ){
      color = this.initcolors.errorColor
    }
    // console.log(color);
    mesh.oldcolor  =color
    mesh.material.albedoColor = color
  }
  meshInsWarn(meshid,warn){
    let meshIns = this.scene.getMeshByID(meshid).getChildMeshes()[0]
    if(warn == 0 ){
      meshIns.instancedBuffers.color = this.initcolors.battery
      meshIns.oldcolor = this.initcolors.battery
    }
    if(warn == 1 ){
      meshIns.instancedBuffers.color = this.initcolors.warningColor
      meshIns.oldcolor = this.initcolors.warningColor
    }
    if(warn == 2 ){
      meshIns.instancedBuffers.color = this.initcolors.errorColor
      meshIns.oldcolor = this.initcolors.errorColor
    }
  }
  async init() {
    this.dom = this.initDom();
    this.eventbus = new EventBus();
    this.engine = new BABYLON.Engine(this.dom, true);
    this.scene = new Scene(this.engine);


    this.leftKeyDown = false;
    this.isDrag = false;
    this.scene.onPointerObservable.add((t) => {

      if (t.type == 1) {
        this.leftKeyDown = true;
      }
      if (t.type == 4 && this.leftKeyDown) {
        this.isDrag = true;
        this.eventbus.$emit('draging')
      } else {
        this.isDrag = false;
      }
      if (t.type == 2) {
        this.leftKeyDown = false;
      }
      if (t.type == 4 && t.pickInfo.pickedMesh) {
        // console.log(t.pickInfo.pickedMesh.name);
      } else {
      }
    });



    this.initMats()
    this.initColors()

    this.camera = new Camera(this.scene, this.dom);

    this.loader = new Loader();

    addGrass(this)
    addSky(this)
    this.lignt = addPoiLight(this)
    await this.loader.end();
    // addScene(this)
    // addRoads()


    this.initIn();

    //debuggerlayer
    // this.scene.debugLayer.show({ embedMode: true })  ;
    this.level = 0
    this.eventbus.$on('levelchange',(p)=>{
      this.level = p
      this.camera.setlevel(p)
    });
    document.body.addEventListener('keydown', event => {
      //esc键
      if (event.keyCode == 27) {
        if (this.level == 4) {
          this.activeIn.hideModels()
          this.eventbus.$emit("levelchange", 3);
        }else{
          this.resetAll();
          this.eventbus.$emit("levelchange", 0);
          // this.resetAll();
        }
      }
    });
  }
  initMats(){
    this.pingtaiMat = genPingtaiMat(this.scene)
  }
  initIn() {
    this.powerBoxIn = new Equipment('powerBox');
    this.electricalBoxIn = new Equipment('electricalBox');
    this.windIn = new Equipment('wind');
    this.lightIn = new Equipment('light');
    this.parkIn = new Equipment('park');
    this.towerIn = new Equipment('tower');
  }
  productInshide() {
      try {this.product1In.hide();} catch (error) {}
      try {this.product2In.hide();} catch (error) {}
      try {this.product3In.hide();} catch (error) {}
      try {this.product4In.hide();} catch (error) {}
      try {this.product5In.hide();} catch (error) {}
      try {this.product6In.hide();} catch (error) {}
      try {this.product7In.hide();} catch (error) {}
  }
  resetAll() {
    this.activeOut = null;
    this.activeIn = null;
    levelsShowIns.eventbus.$emit('levelchange', 0);
    levelsShowIns.eventbus.$emit('inpois', []);
    levelsShowIns.eventbus.$emit('meshhide', { id:0, visibility: 1 });
    levelsShowIns.camera.cameraGo(
      this.activeProject.initCameraCfg.campoi,
      this.activeProject.initCameraCfg.lookat,
      500
    );
    this.productInshide();
  }
  initDom() {
    let dom = document.createElement('canvas');
    dom.style.width = '100%';
    dom.style.height = '100%';
    // dom.style.position = 'fixed';
    dom.style.outline = 'none';
    dom.style.zIndex = 998;
    return dom;
  }
  //   scene.registerBeforeRender(function () {  unregisterBeforeRender
  render() {
    this.engine.runRenderLoop(() => {
      this.scene.render();
    });
  }
  // 划入划出都会触发
  poplabel(product) {
    let l = 0;
    let t = 0;
    let name = null;
    if (!product) {
      this.eventbus.$emit('objectMouseOver', { l, t, name });
      return false;
    }
    if(!product.mesh){ //插箱
      product = {mesh:product}
      product.name = product.mesh.name
      name = product.mesh.$modeinfo.cu.cluName+product.mesh.$modeinfo.name;
    }else{
      name =product.mesh.$objinfo.meta.name;
    }
    var res = worldToScreen(
      product.mesh.getBoundingInfo().boundingBox.centerWorld,
      this.camera,
      this.scene,
      this.engine
    );
    l = res._x;
    t = res._y;
    // let type =  _.findKey(config.typesKey,(a,b)=>{return a == product.type})
    this.eventbus.$emit('objectMouseOver', { l, t, name });
    this.eventbus.$emit('objectClick', product.mesh.$modeinfo);
  }
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/LevelsShow.js